<div class="min-h-screen bg-neutral-3 rounded-2xl p-4">
  <div class="max-w-6xl mx-auto">
    <div class="flex justify-between items-center py-2 px-6 mb-8">
      <h1 class="text-4xl font-bold">
        Latest News
      </h1>
      
      <app-add-button 
        label="Add News" 
        (clicked)="navigateToEditor()" 
      />
    </div>

    @if (news(); as list) {
      @if (list.length === 0) {
        <div class="text-center py-12">
          <div class="text-gray-500 text-lg">No news available yet.</div>
          <button
            (click)="navigateToEditor()"
            class="mt-4 bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg transition"
          >
            Create First News
          </button>
        </div>
      } @else {
        <div class="grid grid-cols-1 gap-6">
          @for (item of list; track item.id) {
            <app-news-item [news]="item" />
          }
        </div>
      }
    } @else {
      <div class="text-center py-12 text-gray-500 text-xl">Loading news…</div>
    }
  </div>
</div>
